import { useMemo } from 'react';
import { getIsHotColdSection } from 'features/hotCold';
import type ISectionSettings from 'types/models/ISectionSettings';

export const useDisplayGamesCount = (data: ISectionSettings): number => {
  return useMemo(() => {
    if (!getIsHotColdSection(data)) {
      return data.games.length;
    }

    return data.hotColdSettings.coldGames.length + data.hotColdSettings.hotGames.length;
  }, [data]);
};
